<script setup>
import { computed, ref } from 'vue'
import { pickBy, isNil } from 'lodash-es'

const props = defineProps({
  queryBody: {
    type: Object,
    default: null,
  },
})

const isOpen = ref(false)

const prettyQuery = computed(() => {
  const source = props.queryBody ?? {}
  const params = source.params ? pickBy(source.params, (value) => !isNil(value)) : undefined

  return {
    ...source,
    ...(params ? { params } : {}),
  }
})
</script>

<template>
  <v-menu
    v-model="isOpen"
    :close-on-content-click="false"
    offset-y
    max-width="30rem"
    max-height="40rem"
    min-width="20rem"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        x-small
        v-bind="attrs"
        v-on="on"
        aria-label="Show search parameters"
      >
        <v-icon>mdi-information-outline</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-subtitle class="py-2 d-flex align-center">
        <span>Search parameters</span>
        <v-spacer />
        <v-btn
          icon
          small
          aria-label="Close search parameters"
          @click="isOpen = false"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-subtitle>

      <v-card-text class="py-0">
        <pre class="pb-0">{{ JSON.stringify(prettyQuery, null, 4) }}</pre>
      </v-card-text>
    </v-card>
  </v-menu>
</template>
